import React, { useState, Fragment } from "react";
import {
  Button,
  TableCell,
  Box,
  TableRow,
  Stack,
  IconButton,
  Tooltip,
  Chip,
  Typography,
  CircularProgress,
  Grid,
} from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import TextDecreaseIcon from "@mui/icons-material/TextDecrease";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../../assets";
import qs from "qs";
import ImageIcon from "@mui/icons-material/Image";
import noImageFound from "../../../assets/images/no-image-avalible.png";

import PageTitle from "../../../hooks/page-title";
import API from "../../../axios";

// QR code
import { QRCodeCanvas } from "qrcode.react";
import QRCodeWebcam from "./QRCodeWebcam";
import {
  SelectBox,
  InputField,
  CustomModal,
  UsePagination,
  TableWrapper,
  OrderDataBtn,
  MultiSelect,
  InfoHeading,
} from "../../../components";
import ComponentForm from "./comp-form";
import { icon1, icon2, icon3 } from "../../../assets";
import ComponentLayout from "./component-layout";
import { useDispatch, useSelector } from "react-redux";
import ApiImage from "../../../hooks/fetch-image";

//import redux filter function
import {
  openPopUp,
  setPaginationCurrent,
  clearFilters,
  setPerPage,
  setSearch,
  setStatus,
  setLanguage,
  setOrderBy,
  setIsFilterApply,
} from "../../../store/reducer";

export default function ComponentsPanel() {
  const {
    selectedLang,
    language,
    user,
    pagination_number,
    perPage,
    search,
    status,
    language1,
    technologies,
    orderBy,
    isFilterApply,
  } = useSelector((state) => state.storeReducer);

  PageTitle(language[selectedLang]?.component);
  const [isMobile, setIsMobile] = useState(false);
  const [createCompModal, setCreateCompModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dltLoading, setDltLoading] = useState(false);
  const [records, setRecords] = useState(null);
  const [ID, setID] = useState(null);
  const [openM2, setOpenM2] = useState(false);
  const [openM3, setOpenM3] = useState(false);
  const [QRData, setQRData] = useState();
  const [serial, setSerial] = useState("");
  const [quantity, setQuantity] = useState("");
  const [addText, setAddText] = useState(false);
  // Qr code
  const [openWebCam, setOpenWebCam] = useState(false);
  const [columns, setColumns] = useState(_columns);
  const [toggler, setToggler] = useState(false);
  // const [IsFilterApply, setIsFilterApply] = React.useState(false);
  const [Quantities, setQuantities] = useState(0);
  const [AllActive, setAllActive] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination_number, orderBy, perPage]);

  // Get Screen Size
  React.useEffect(() => {
    setIsMobile(window.innerWidth < 500);
    const handleResizeWindow = () => setIsMobile(window.innerWidth < 500);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  const closeModal = () => setCreateCompModal(false);

  const applyFilters = () => {
    dispatch(setPaginationCurrent(1));
    dispatch(setIsFilterApply(true));
    getData();
  };

  const clearAllFilters = () => {
    dispatch(setIsFilterApply(false));
    dispatch(setPaginationCurrent(1));
    dispatch(clearFilters());
    getData();
  };

  const getData = async () => {
    setIsLoading(true);
    try {
      const params = {
        page: pagination_number,
        per_page: perPage,
        search: search,
        componenttype: "",
        active: status === "active" ? 1 : 0,
        inactive: status === "disable" ? 1 : 0,
        battery_storage: technologies === "battery_storage" ? 1 : 0,
        energy_management: technologies === "energy_management" ? 1 : 0,
        photovoltaic: technologies === "photovoltaic" ? 1 : 0,
        column: orderBy.name,
        orderby: orderBy.order,
        counting: true,
      };
      let { data } = await API(
        "get",
        "manager/components?" + qs.stringify(params)
      );
      setRecords(data[2]);
      setAllActive(data[0]);
      setQuantities(data[1]);
      setIsLoading(false);
    } catch (error) {
      if (!!records) setRecords(null);
      setIsLoading(false);
    }
  };

  const handleQuantity = async () => {
    if (!quantity) return;
    setDltLoading(true);
    const form = new FormData();
    form.append("serial", serial);
    form.append("quantity", quantity);
    try {
      await API("post", `manager/add-component-quantity-logs/${ID}`, form);
      dispatch(
        openPopUp({
          message: "Quantity Decrease Successfully!",
          type: "success",
        })
      );
      getData();
      setDltLoading(false);
      setOpenM2(false);
      setAddText(false);
    } catch (error) {
      dispatch(
        openPopUp({ message: error?.response?.data?.message, type: "error" })
      );
      setOpenM2(false);
      setDltLoading(false);
      setAddText(false);
    }
  };

  const useFilters = () => {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <Box>
          <Box>
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-end"
              spacing={1}
              flexWrap="wrap"
              sx={{ "& > div,& > button": { marginTop: "10px !important" } }}
            >
              <Grid container spacing={2}>
                <Grid item md={4} sm={6} xs={12}>
                  <InputField
                    size="small"
                    label={language[selectedLang]?.common_search}
                    handleChange={(e) => {
                      dispatch(setSearch(e.target.value));
                      dispatch(setIsFilterApply(true));
                    }}
                    initValue={search}
                    fullWidth
                  />
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <SelectBox
                    items={langOptions}
                    label={language[selectedLang]?.language}
                    size="small"
                    initValue={language1}
                    handleChange={(e) => {
                      dispatch(setLanguage(e.target.value));
                      dispatch(setIsFilterApply(true));
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <SelectBox
                    items={[
                      { label: "Active", value: "active" },
                      { label: "Disabled", value: "disable" },
                    ]}
                    label={language[selectedLang]?.status}
                    size="small"
                    initValue={status}
                    fullWidth
                    handleChange={(e) => {
                      dispatch(setStatus(e.target.value));
                      dispatch(setIsFilterApply(true));
                    }}
                  />
                </Grid>
              </Grid>
              {(search || technologies || language1 || status) !== "" && (
                <Button
                  variant="contained"
                  sx={{ borderRadius: "25px", textTransform: "none" }}
                  onClick={() => {
                    dispatch(setPaginationCurrent(1));
                    applyFilters();
                  }}
                >
                  {language[selectedLang]?.filter}
                </Button>
              )}
              {isFilterApply && (
                <Button
                  variant="contained"
                  sx={{ borderRadius: "25px", textTransform: "none" }}
                  onClick={() => {
                    dispatch(setPaginationCurrent(1));
                    clearAllFilters();
                  }}
                >
                  {language[selectedLang]?.common_clear}
                </Button>
              )}
            </Stack>
          </Box>
          <Box sx={{ mt: "15px" }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              alignItems="flex-start"
              spacing={3}
            >
              {!isMobile && (
                <Box sx={{ width: { xs: "100%", sm: "50%", md: "40%" } }}>
                  <MultiSelect
                    columnsList={columns}
                    setColumnsList={(e) => {
                      setColumns(e);
                      setToggler(!toggler);
                    }}
                  />
                </Box>
              )}
              <SelectBox
                label={language[selectedLang]?.shown}
                size="small"
                items={rowsOption}
                handleChange={(e) => {
                  dispatch(setPerPage(e.target.value));
                  dispatch(setIsFilterApply(true));
                }}
                initValue={perPage}
                styles={{ width: { xs: "100%", sm: "50%", md: "40%" } }}
              />
            </Stack>
          </Box>
        </Box>
        <Box sx={{ display: { md: "block", xs: "none" } }}>
          {/* <img src={Logo} width="150px" alt="" /> */}
        </Box>
      </Stack>
    );
  };

  const downloadQRCode = () => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `gama_qr_code.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const printTh = () => {
    return (
      <>
        {isMobile && <TableCell width="20px"></TableCell>}
        {columns.map((v, i) => {
          if (!v.show) return <></>;
          if (user?.role !== "stock_manager" && v.id === 11) return <></>;
          if (isMobile && (v.id === 3 || v.id === 12)) {
            return (
              <Fragment key={i}>
                {v.type === "simple_label" && (
                  <TableCell>{language[selectedLang]?.[v.label]}</TableCell>
                )}
                {v.type === "order_label" && (
                  <TableCell>
                    <OrderDataBtn
                      handleBtn={() => {
                        dispatch(setOrderBy);
                      }}
                      selected={orderBy.name}
                      value={v.value}
                      title={language[selectedLang]?.[v.label]}
                    />
                  </TableCell>
                )}
              </Fragment>
            );
          } else if (isMobile) return <></>;
          return (
            <Fragment key={i}>
              {v.type === "simple_label" && (
                <TableCell>{language[selectedLang]?.[v.label]}</TableCell>
              )}
              {v.type === "order_label" && (
                <TableCell>
                  <OrderDataBtn
                    handleBtn={dispatch(setOrderBy)}
                    selected={orderBy.name}
                    value={v.value}
                    title={language[selectedLang]?.[v.label]}
                  />
                </TableCell>
              )}
            </Fragment>
          );
        })}
      </>
    );
  };

  const footerContent = () => {
    if (isMobile) {
      return <></>;
    }
    return (
      <>
        <TableCell sx={{ color: "#fff" }}>
          <Stack direction="column" alignItems="center">
            <Typography fontSize={13}> {language[selectedLang]?.common_count}</Typography>
            <Typography fontSize={13}>{records?.total ?? 0}</Typography>
          </Stack>
        </TableCell>
        <TableCell sx={{ color: "#fff" }}></TableCell>
        <TableCell sx={{ color: "#fff" }}>
          <Stack direction="column" alignItems="center">
            <Typography fontSize={13}>{language[selectedLang]?.common_types}</Typography>
            <Typography fontSize={13}>{records?.total ?? 0}</Typography>
          </Stack>
        </TableCell>
        <TableCell sx={{ color: "#fff" }}></TableCell>
        <TableCell sx={{ color: "#fff" }}></TableCell>
        <TableCell sx={{ color: "#fff" }}></TableCell>
        <TableCell sx={{ color: "#fff" }}>
          <Stack direction="column" alignItems="center">
            <Typography fontSize={13}>{language[selectedLang]?.common_technologies}</Typography>
            <Typography fontSize={13}>{records?.total ?? 0}</Typography>
          </Stack>
        </TableCell>
        <TableCell sx={{ color: "#fff" }}></TableCell>
        <TableCell sx={{ color: "#fff" }}>
          <Stack direction="column" alignItems="center">
            <Typography fontSize={13}>{language[selectedLang]?.common_active}</Typography>
            <Typography fontSize={13}>{AllActive ?? 0}</Typography>
          </Stack>
        </TableCell>
        <TableCell sx={{ color: "#fff" }}></TableCell>
        <TableCell sx={{ color: "#fff" }}>
          <Stack direction="column" alignItems="center">
            <Typography fontSize={13}>{language[selectedLang]?.common_quantity}</Typography>
            <Typography fontSize={13}>{Quantities ?? 0}</Typography>
          </Stack>
        </TableCell>
        <TableCell sx={{ color: "#fff" }}></TableCell>
        <TableCell sx={{ color: "#fff" }}></TableCell>
      </>
    );
  };

  return (
    <ComponentLayout>
      <Box>
        {useFilters()}
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid container>
            <Grid item md={6} sm={6} xs={12}>
              <Typography component="h6" variant="h6">
                {language[selectedLang]?.component}
              </Typography>
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              {user?.role === "stock_manager" && (
                <Stack
                  mb={1}
                  justifyContent="flex-end"
                  spacing={1}
                  direction="row"
                >
                  <Button
                    onClick={() => setOpenWebCam(true)}
                    variant="contained"
                  >
                    {language[selectedLang]?.webcam}
                  </Button>
                  <Button
                    onClick={() => setCreateCompModal(true)}
                    variant="contained"
                  >
                    {language[selectedLang]?.common_add}
                  </Button>
                </Stack>
              )}
            </Grid>
          </Grid>
        </Stack>
        <Box>
          {records?.last_page > 1 && (
            <Box component="div" mb={3} mt={2}>
              <UsePagination
                total={records?.total}
                perPage={records?.per_page}
                page={records?.current_page}
                key={records?.last_page}
              />
            </Box>
          )}
          <TableWrapper
            thContent={printTh()}
            FooterContent={footerContent()}
            spanTd="11"
            isLoading={isLoading}
            isContent={records?.data.length}
          >
            {records?.data.map((v, i) => {
              return (
                <TableRow key={i}>
                  {!isMobile && columns[0]?.show && (
                    <TableCell sx={{ textAlign: "center" }}>#{v.id}</TableCell>
                  )}
                  {columns[1]?.show && (
                    <TableCell
                      sx={{ textAlign: "center", cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/admin/components/${v.id}`, {
                          id: v.id,
                        })
                      }
                    >
                      <MyImage id={v?.id} />
                    </TableCell>
                  )}
                  {!isMobile && columns[2]?.show && (
                    <TableCell>{v.componenttypes.title}</TableCell>
                  )}
                  {columns[3]?.show && (
                    <TableCell>
                      <Box>
                        {v.active ? (
                          v.name || "-"
                        ) : (
                          <InfoHeading
                            color="error"
                            iconColor="error"
                            infoText="The component has been archived and should not be used."
                            text={v.name}
                          />
                        )}
                      </Box>
                    </TableCell>
                  )}
                  {!isMobile && columns[4]?.show && (
                    <TableCell>{v.item_number ?? "-"}</TableCell>
                  )}
                  {!isMobile && columns[5]?.show && <TableCell>-</TableCell>}
                  {!isMobile && columns[6]?.show && (
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        {v?.photovoltaic && (
                          <Tooltip title="Photovoltaic" placement="top">
                            <div className="cube">
                              <img src={icon1} alt="" />
                            </div>
                          </Tooltip>
                        )}
                        {v?.battery_storage && (
                          <Tooltip title="Battery Storage" placement="top">
                            <div className="cube">
                              <img src={icon2} alt="" />
                            </div>
                          </Tooltip>
                        )}
                        {v?.energy_management && (
                          <Tooltip title="Energy Management" placement="top">
                            <div className="cube">
                              <img src={icon3} alt="" />
                            </div>
                          </Tooltip>
                        )}
                      </Stack>
                    </TableCell>
                  )}
                  {!isMobile && columns[7]?.show && <TableCell>-</TableCell>}
                  {!isMobile && columns[8]?.show && (
                    <TableCell>
                      {v.active ? (
                        <Chip
                          label={language[selectedLang]?.common_active}
                          color="primary"
                        />
                      ) : (
                        <Chip label={language[selectedLang]?.common_disabled} />
                      )}
                    </TableCell>
                  )}
                  {!isMobile && columns[9]?.show && <TableCell>-</TableCell>}
                  {!isMobile && columns[10]?.show && (
                    <TableCell>
                      {v?.quantity <= v?.min_quantity ? (
                        <Chip label={v?.quantity} color="error" />
                      ) : (
                        v?.quantity ?? "-"
                      )}
                    </TableCell>
                  )}
                  {!isMobile && columns[11]?.show && (
                    <TableCell>{v?.min_quantity ?? "-"}</TableCell>
                  )}

                  {columns[12]?.show && user?.role === "stock_manager" && (
                    <TableCell style={{ verticalAlign: "top" }}>
                      <Tooltip title="Edit" placement="top">
                        <IconButton
                          onClick={() =>
                            navigate(`/admin/components/${v.id}`, {
                              id: v.id,
                            })
                          }
                          color="primary"
                        >
                          <CreateIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="QR Code" placement="top">
                        <IconButton
                          onClick={() => {
                            setQRData([
                              v?.id,
                              localStorage.getItem("@ACCESS_TOKEN"),
                            ]);
                            setOpenM3(true);
                          }}
                          color="primary"
                        >
                          <QrCode2Icon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Decrease Quantity" placement="top">
                        <IconButton
                          onClick={() => {
                            setOpenM2(true);
                            setID(v?.id);
                          }}
                          color="error"
                        >
                          <TextDecreaseIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableWrapper>
          {records?.last_page > 1 && (
            <Box component="div" sx={{ mt: 4 }}>
              <UsePagination
                total={records?.total}
                perPage={records?.per_page}
                page={records?.current_page}
                key={records?.last_page}
              />
            </Box>
          )}
        </Box>
      </Box>
      {createCompModal && user?.role === "stock_manager" ? (
        <CustomModal
          width="850px"
          children={<ComponentForm handleClose={closeModal} />}
          handleClose={closeModal}
        />
      ) : null}
      {openM2 ? (
        <CustomModal
          handleClose={() => setOpenM2(false)}
          children={
            <Box py={3}>
              <Typography mb={2} variant="h6" sx={{ textAlign: "center" }}>
                {language[selectedLang]?.delete_message_message}
              </Typography>
              {addText && (
                <>
                  <InputField
                    size="small"
                    label="Serial Number"
                    handleChange={(e) => setSerial(e.target.value)}
                    initValue={serial}
                    fullWidth
                    styles={{ mb: 3 }}
                  />
                  <InputField
                    type="number"
                    size="small"
                    label="Quantity"
                    required
                    handleChange={(e) => setQuantity(e.target.value)}
                    initValue={quantity}
                    fullWidth
                    styles={{ mb: 3 }}
                  />
                </>
              )}
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                spacing={2}
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    setOpenM2(false);
                    setAddText(false);
                  }}
                >
                  {language[selectedLang]?.common_no}
                </Button>
                {addText ? (
                  <Button
                    variant="contained"
                    color="info"
                    onClick={() => handleQuantity()}
                    disabled={dltLoading}
                  >
                    {dltLoading && (
                      <CircularProgress size={16} color="primary" />
                    )}
                    Submit
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="info"
                    onClick={() => setAddText(true)}
                    disabled={dltLoading}
                  >
                    {language[selectedLang]?.common_yes}
                  </Button>
                )}
              </Stack>
            </Box>
          }
        />
      ) : null}
      {openM3 ? (
        <CustomModal
          handleClose={() => {
            setOpenM3(false);
          }}
          children={
            <Box py={3}>
              <Typography mb={1} variant="h6" sx={{ textAlign: "center" }}>
                QR Code
              </Typography>

              <Box maxWidth="450px">
                <QRCodeCanvas
                  onClick={downloadQRCode}
                  size={512}
                  style={{
                    height: "auto",
                    maxWidth: "100%",
                    width: "100%",
                    cursor: "pointer",
                  }}
                  value={QRData}
                  id="qr-gen"
                  level={"H"}
                  fgColor="#010000"
                  includeMargin={true}
                  imageSettings={{
                    src: Logo,
                    x: undefined,
                    y: undefined,
                    height: 48,
                    width: 110,
                    excavate: true,
                  }}
                />
                {/* </button> */}
                <p
                  style={{
                    color: "#B0B0B0",
                    textAlign: "center",
                    marginTop: "1  0px",
                  }}
                >
                  {/* {qrCodeUrl} */}
                </p>
              </Box>
            </Box>
          }
        />
      ) : null}
      {openWebCam ? (
        <CustomModal
          handleClose={() => {
            setOpenWebCam(false);
          }}
          children={
            <Box py={3}>
              {openWebCam && (
                <QRCodeWebcam
                  handleClose={() => setOpenWebCam(false)}
                  getData={getData}
                />
              )}
            </Box>
          }
        />
      ) : null}
    </ComponentLayout>
  );
}

const MyImage = ({ id }) => {
  const image = ApiImage(`component-image/${id}`);
  
  return (
    <>
      {image ? (
        <img alt="..." src={image} width="50" height="50" />
        ) : (
        <img alt="..." src={noImageFound} width="50" height="50" />
      )}
    </>
  );
};

const rowsOption = [
  { label: "25 Rows", value: "25" },
  { label: "50 Rows", value: "50" },
  { label: "75 Rows", value: "75" },
  { label: "100 Rows", value: "100" },
];

const langOptions = [
  { label: "Deutsch (CH)", value: "dutch" },
  { label: "English", value: "english" },
];

const _columns = [
  {
    id: 0,
    label: "org_component_id",
    value: "id",
    show: true,
    type: "simple_label",
  },
  {
    id: 1,
    label: "org_component_image",
    value: "component_image",
    show: true,
    type: "simple_label",
  },
  {
    id: 2,
    label: "component_type",
    value: "component_type",
    show: true,
    type: "simple_label",
  },
  {
    id: 3,
    label: "common_name",
    value: "name",
    show: true,
    type: "order_label",
  },
  {
    id: 4,
    label: "item_number",
    value: "item_number",
    show: true,
    type: "order_label",
  },
  {
    id: 5,
    label: "unit",
    value: "fourth_col",
    show: true,
    type: "simple_label",
  },
  {
    id: 6,
    label: "technologies",
    value: "fifth_col",
    show: true,
    type: "simple_label",
  },
  {
    id: 7,
    label: "language",
    value: "sixth_col",
    show: true,
    type: "simple_label",
  },
  {
    id: 8,
    label: "status",
    value: "seventh_col",
    show: true,
    type: "simple_label",
  },
  {
    id: 9,
    label: "tags",
    value: "eight_col",
    show: true,
    type: "simple_label",
  },
  {
    id: 10,
    label: "quantity",
    value: "quantity",
    show: true,
    type: "order_label",
  },
  {
    id: 11,
    label: "org_min_quantity",
    value: "min_quantity",
    show: true,
    type: "order_label",
  },
  {
    id: 12,
    label: "common_action",
    value: "eleventh_col",
    show: true,
    type: "simple_label",
  },
];
